/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { StockOrderBase } from "../../../../schema/generated/StockOrder";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class StockOrderDataApi extends EntityDataApi<StockOrderBase> {
  public readonly def = idbEntityDefs.StockOrder;
}